import { generateTranslationHook } from "../utils/translation-hook-generator";

export type HomeMessages = typeof import("../../../locales/en/home.json");

export const useHomeTranslations =
	generateTranslationHook<HomeMessages>("home");
